import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from '@/router'
import store from './store'
import './registerServiceWorker'
import Snackbar from './components/Snackbar'
import '@/styles/index.styl'
import LongPress from 'vue-directive-long-press'
import VueNativeSock from 'vue-native-websocket'
import { connectionHandler } from '@/services'
import * as swUpdateHandler from '@/services/swUpdateHandler'

Vue.use(
  VueNativeSock,
  process.env.VUE_APP_WEBSOCKET_URL,
  { store, reconnection: true, format: 'json' }
)

Vue.config.productionTip = false

Vue.component('snackbar', Snackbar)

Vue.directive('long-press', LongPress)

connectionHandler.initConnectionEventListener(store)

swUpdateHandler.initHandler(store)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
